export { StageColorSquare } from './StageColorSquare';
